import { CSSProperties } from 'react';
import { Colors } from '~/themes/colors';

export const Styles = {
  Body: {
    gap: 4,
    marginTop: 4,
  } satisfies CSSProperties,
  BodyRowItem: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    padding: '16px',
    cursor: 'default',
    alignItems: 'center',
  } satisfies CSSProperties,
  Header: {
    alignItems: 'center',
    display: 'grid',
    gridTemplateColumns: '1fr',
    padding: '12px 16px',
  } satisfies CSSProperties,
  HeaderSticky: {
    backgroundColor: Colors.white,
    position: 'sticky',
    top: 0,
    zIndex: 1,
  } satisfies CSSProperties,
};
